import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./LanguageContext";
import { AuthProvider } from "./AuthContext";
import { SettingsProvider } from "./SettingsContext";
import { CurrencyProvider } from "./CurrencyContext";
import { EditModeProvider } from "./EditModeContext";
import InlineEditor from "./components/InlineEditor";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import WhatsAppButton from "./components/WhatsAppButton";
import ExitIntentPopup from "./components/ExitIntentPopup";
import Home from "./pages/Home";
import Services from "./pages/Services";
import { useAnalytics } from "./hooks/useAnalytics";
import About from "./pages/About";
import Booking from "./pages/Booking";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import Journal from "./pages/Journal";
import JournalPost from "./pages/JournalPost";
import Consultation from "./pages/Consultation";
import GiftCards from "./pages/GiftCards";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Account from "./pages/Account";
import AdminLayout from "./pages/AdminLayout";
import { useLocation } from "react-router-dom";

function AppShell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  useAnalytics();
  return (
    <div className="App min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal/:slug" element={<JournalPost />} />
          <Route path="/consultation" element={<Consultation />} />
          {/* Legacy /quiz redirects to /consultation */}
          <Route path="/quiz" element={<Consultation />} />
          <Route path="/gift-cards" element={<GiftCards />} />
          <Route path="/about" element={<About />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin/*" element={<AdminLayout />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
      {!isAdmin && <Footer />}
      {!isAdmin && <ChatWidget />}
      {!isAdmin && <WhatsAppButton />}
      {!isAdmin && <ExitIntentPopup />}
      {!isAdmin && <InlineEditor />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <SettingsProvider>
            <CurrencyProvider>
              <EditModeProvider>
                <AppShell />
              </EditModeProvider>
            </CurrencyProvider>
          </SettingsProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
